module.exports = __webpack_public_path__ + "img/mailBlack.54ea4e14.gif";